import React, { useEffect, useState } from 'react';
import { Smartphone } from 'lucide-react';
import { toast } from 'sonner';

const IOS_HINT = 'On iPhone: tap the Share button, then "Add to Home Screen" to install the Jess Sells app.';

export const InstallAppLink = ({ className = '' }) => {
  const [promptEvent, setPromptEvent] = useState(null);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPromptEvent(e); };
    window.addEventListener('beforeinstallprompt', onPrompt);
    return () => window.removeEventListener('beforeinstallprompt', onPrompt);
  }, []);

  const handleInstall = async () => {
    if (promptEvent) {
      promptEvent.prompt();
      setPromptEvent(null);
      return;
    }
    toast('Get the Jess Sells App', { description: IOS_HINT, duration: 8000 });
  };

  return (
    <button
      type="button"
      onClick={handleInstall}
      data-testid="install-app-link"
      aria-label="Download the Jess Sells East Coast mobile app"
      className={`inline-flex items-center space-x-2 ${className}`}
    >
      <Smartphone className="w-4 h-4" />
      <span>Get the Mobile App</span>
    </button>
  );
};
